// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tRWP","content":"styles_content__WW0yI","row":"styles_row__1ZZ8S","footer":"styles_footer__3voVP","phraseLength":"styles_phraseLength__1Em-P"};